import { useEffect } from "react";

/**
 * Cinematic dark hero section for inner pages (About, FAQ, How It Works).
 * Adds dark body background while mounted.
 */
export default function DarkPageHero({ overline, title, subtitle, children }) {
  useEffect(() => {
    document.body.setAttribute("data-dark", "true");
    return () => document.body.removeAttribute("data-dark");
  }, []);

  return (
    <section className="relative pt-36 pb-20 px-5 lg:px-10 overflow-hidden bg-[#040914] text-white">
      {/* Aurora */}
      <div className="aurora aurora-anim w-[600px] h-[600px] -top-40 -left-40 bg-[#52BFB8]/25" />
      <div className="aurora aurora-anim w-[500px] h-[400px] top-0 right-0 bg-[#3E9690]/20" style={{ animationDelay: "3s" }} />
      <div className="absolute inset-0 caribbean-grid opacity-50" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-[#040914]" />

      <div className="relative max-w-4xl mx-auto text-center">
        {overline && (
          <p className="text-xs tracking-[0.3em] uppercase text-[#52BFB8] font-semibold mb-4">
            {overline}
          </p>
        )}
        <h1 className="font-cabinet text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-lg md:text-xl text-[#9BA8C4] max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </section>
  );
}
